<script>
export default {
    props: {
        item_key: {
        type: String,
        required: true,
        },
        item_value: {
        type: Boolean,
        required: false,
        },
        item: {
        type: Object,
        required: true,
        },
        submitted: {
        type: Boolean,
        required: true,
        },
        validation: {
        type: Object,
        required: true,
        },
        updateValue: {
            type: Function,
            required: true
        }
    },
    components: {
    },
    data() {
        return {
            value: this.item_value
        };
    },
    watch: {
        item_value: {
            handler(val) {
                this.value = val;
            },
            deep: true
        },
        value(val) {
            this.updateValue(this.item_key, val);
        }
    }
};
</script>
<template>
    <div class="">
        <div class="form-check">
            <input class="form-check-input mt-2" type="checkbox" id="checkbox" v-model="value">
            <label
                class="ml-1 mb-2 pr-2 my-1 align-self-sm-center font-theme-black-color font-weight-medium">
                {{item.label}}
                <span v-if="item.required"> *</span>  
            </label>
            <img v-if="item.info" variant="primary" class="align-self-center" src="@/assets/images/info.svg" alt="">
            <b-tooltip :target="item.label || ''">{{item.tooltip ? item.tooltip : 'Enter ' + item.label}}</b-tooltip>
        </div>
        <div v-if="submitted && validation.$error" class="invalid-feedback">
        <span v-if="!validation.required">This value is required.</span>
        </div>
    </div>
</template>